export const SET_DSR_TEMPLATE_ID = 'set_dsr_template_id'
export const SET_DSR_TEMPLATE_MAIN_CONTACT = 'set_dsr_template_main_contact'

export const GET_DSR_TEMPLATE_CONFIG_REQUEST = 'get_dsr_template_config_request';
export const GET_DSR_TEMPLATE_CONFIG_SUCCESS = 'get_dsr_template_config_success';
export const GET_DSR_TEMPLATE_CONFIG_FAILURE = 'get_dsr_template_config_failure';

export const CREATE_DSR_TEMPLATE_REQUEST = 'create_dsr_template_request';
export const CREATE_DSR_TEMPLATE_SUCCESS = 'create_dsr_template_success';
export const CREATE_DSR_TEMPLATE_FAILURE = 'create_dsr_template_failure';
// Reset

export const UPDATE_DSR_TEMPLATE_REQUEST = 'update_dsr_template_request';
export const UPDATE_DSR_TEMPLATE_SUCCESS = 'update_dsr_template_success';
export const UPDATE_DSR_TEMPLATE_FAILURE = 'update_dsr_template_failure';
export const UPDATE_DSR_TEMPLATE_RESET = 'update_dsr_template_reset';

export const CREATE_DSR_WITH_TEMPLATE_REQUEST = 'create_dsr_with_template_request';
export const CREATE_DSR_WITH_TEMPLATE_SUCCESS = 'create_dsr_with_template_success';
export const CREATE_DSR_WITH_TEMPLATE_FAILURE = 'create_dsr_with_template_failure';
export const CREATE_DSR_WITH_TEMPLATE_RESET = 'create_dsr_with_template_reset';

export const UPDATE_DSR_TEMPLATE_FAQ_REQUEST = 'update_dsr_template_faq_request';
export const UPDATE_DSR_TEMPLATE_FAQ_SUCCESS = 'update_dsr_template_faq_success';
export const UPDATE_DSR_TEMPLATE_FAQ_FAILURE = 'update_dsr_template_faq_failure';
export const UPDATE_DSR_TEMPLATE_FAQ_RESET = 'update_dsr_template_faq_reset';